import { useEffect, useState } from 'react';

/**
 * Executa um carregamento inicial quando `deps` mudam e só retorna `true` após a Promise
 * do `fetcher` terminar (sucesso ou erro). Útil para não renderizar conteúdo da seção até
 * todas as fontes necessárias terem respondido (incluindo lista vazia).
 */
export function useAwaitInitialFetch(fetcher: () => Promise<void>, deps: readonly unknown[]): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setReady(false);
    void (async () => {
      try {
        await fetcher();
      } finally {
        if (!cancelled) setReady(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, deps);
  return ready;
}
